import {
  ResourceFormFields,
  ResourceTypeEnum,
} from '@/components/resource/ResourceInlineForm';
import Resource from '@/models/Resource';

const resolveType = (resource?: Resource): ResourceTypeEnum => {
  if (resource?.resourceFile) return ResourceTypeEnum.FILE;
  return ResourceTypeEnum.LINK;
};

export const resourceToFields = (resource?: Resource): ResourceFormFields => ({
  title: resource?.title ?? '',
  type: resolveType(resource),
  resourceLink: resource?.resourceLink ?? '',
  resourceFile: null,
  isMandatory: resource?.isMandatory ?? false,
  onlyTeacher: resource?.onlyTeacher ?? false,
  allowDownload: resource?.allowDownload ?? true,
});
